import BaseChannel from './BaseChannel';

class MasterChannel extends BaseChannel {

	constructor() {
		super("CHANNEL_MASTER");
	}

	rehydrate(state) {
		super.rehydrate(state);
	}

	dehydrate() {
		var state = super.dehydrate();
		return state;
	}
}

export default MasterChannel;